import React from 'react'
import { connect } from 'react-redux'
import { Button, Card, Col, Divider, Empty, Image, message, Popconfirm, Row, Spin, Typography } from 'antd'
import { DeleteOutlined, EditOutlined, FileAddOutlined } from '@ant-design/icons'

import '../../asset/less/NewPieces.css'
import { ExcelRenderer } from 'react-excel-renderer'
import { getAllArtistNames } from '../../api/artistNames'
import { deleteArtworkExhibition, getAllArtworkExhibitions, postArtworkExhibition, putArtworkExhibition } from '../../api/artworkExhibition'
import HttpError from '../../component/base/HttpError'
import { withRouter } from 'react-router'
import moment from 'moment'
import { getEditUrl, getExhibitionDetailUrl } from '../../component/Utils'
import { URL_ADMIN_EDIT_EXHIBITIONS_ID, URL_ADMIN_NEW_EXHIBITIONS } from '../../const'

const { Title } = Typography
const { Meta } = Card

@connect((state) => ({
  userId: state.user.info.id,
  email: state.user.info.email,
  role: state.user.info.role,
  artists: state.artist.artists
}))
class Exhibitions extends React.Component {
  constructor(props) {
    super(props)
    this.expoFormRef = React.createRef()
    this.formRef = React.createRef()
    this.state = {
      exibitions: [],
      artistNames: [],
      validateError: [],
      loading: false,
      updateBtnEnabled: true
    }
    this.is_new = props.new
    this.targetId = -1
    if (!this.is_new) {
      let getExpoId = () => {
          let id = ''
          const locationArry = this.props.location.pathname.split('/')
        if(locationArry.length > 0) {
          if(locationArry[locationArry.length - 1]) {
            id = parseInt(locationArry[locationArry.length - 1])
          }else{
            id = parseInt(locationArry[locationArry.length - 2])
          }
        }
        return id
      }
      this.targetId = getExpoId()
    }
  }

  componentDidMount() {
    this.setState({loading: true})
    getAllArtworkExhibitions()
      .then((res) => {
        if (!this.is_new) {
          let target = res.data.results.filter((v) => {
            if (v.id === this.targetId) return v
          })
          if (target && target.length > 0) {
            let value = target[0]
            value['date'] = moment(value['date'], 'YYYY-MM-DD')
            this.formRef.current.setFieldsValue(value)
          }
        }
        this.setState({
          exibitions: res.data.results
        })
      })
      .catch((error) => {
        HttpError(error)
      }).finally(()=>{
        this.setState({
          loading: false
        })
    })
    getAllArtistNames()
      .then((res) => {
        this.setState({ artistNames: res.data })
      })
      .catch((error) => {
        HttpError(error)
      })
  }

  onChange = (info) => {
    if (info.file.status === 'done') {
      this.setState({
        updateBtnEnabled: true,
        loading: false
      })
      message.success(`${info.file.name} file uploaded successfully`).then((r) => {})
    } else if (info.file.status === 'error') {
      this.setState({
        updateBtnEnabled: false,
        loading: false
      })
      message.error(`${info.file.name} file upload failed.`).then((r) => {})
    }
  }

  handleUpload = (f, onSuccess) => {
    ExcelRenderer(f, (err, resp) => {
      if (err) {
        message.error(err).then((r) => {})
      } else {
        let rows = resp.rows.filter((v) => {
          return v.length !== 0
        })
        // const titles = rows[0]
        // const columns = titles.map((item, idx) => {
        //   return {
        //     title: item,
        //     dataIndex: idx,
        //     key: idx,
        //     render: (text, record, index) => (
        //       <span
        //         style={{
        //           display: 'block',
        //           overflow: 'hidden',
        //           whiteSpace: 'nowrap',
        //           textOverflow: 'ellipsis'
        //         }}
        //       >
        //         {text}
        //       </span>
        //     )
        //   }
        // })
        rows.shift()
        // const data = rows.map((item, idx) => {
        //   const obj = {}
        //   for (let i = 0; i < item.length; i++) {
        //     if (item[i]) obj[i] = String(item[i]).trim()
        //   }
        //   return obj
        // })
        let artworkIds = []
        let artistIds = []
        let artistNameMap = {}
        rows.map((v) => {
          if (v.length === 0) return
          const i = 0

          let artistName = v[i]
          artistNameMap[artistName] = artistName
          let skuNum = v[i + 1]
          skuNum = parseInt(skuNum)
          if (skuNum > 0) artworkIds.push(skuNum)
        })
        artistNameMap = Object.keys(artistNameMap).map((v) => {
          return v
        })

        this.state.artistNames.map((v) => {
          if (artistNameMap.indexOf(v.name) > -1) {
            artistIds.push(v.artist_id)
          }
        })

        this.formRef.current.setFieldsValue({
          artist_ids: artistIds.join(','),
          artwork_ids: artworkIds.join(',')
        })
      }
      onSuccess()
    })
  }

  onFinish = (params) => {
    const { date } = params
    if (date) {
      params['date'] = date.format('YYYY-MM-DD')
    }
    this.setState({
      loading: true
    })
    if (this.is_new) {
      postArtworkExhibition(params)
        .then((v) => {
          message.success('Create Successfully').then((r) => {})
          window.location.reload()
        })
        .catch((e) => {
          HttpError(e)
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    } else {
      putArtworkExhibition(this.targetId, params)
        .then((v) => {
          message.success('Update Successfully').then((r) => {})
          window.location.reload()
        })
        .catch((e) => {
          HttpError(e)
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  onFinishFailed = ({ values, errorFields, outOfDate }) => {
    this.setState({ validateError: errorFields })
    window.scrollTo(0, 0)
    window.scrollTop = 0
  }

  customRequest = (options) => {
    const { onSuccess, file } = options
    this.setState({
      loading: true
    })
    this.handleUpload(file, onSuccess)
  }

  render() {
    function getExhibitionsLayout(state, props) {
      const items = []
      if (!state.exibitions || state.exibitions.length === 0) return <Empty />
      state.exibitions.forEach((element, index) => {
        items.push(
          <Col xs={12} sm={8} md={6} key={index}>
            <Card
              loading={state.loading}
              style={{
                marginBottom: '20px'
              }}
              cover={<Image preview={false} src={element.thumbnail} />}
              actions={[
                <EditOutlined
                  key='edit'
                  onClick={(event) => {
                    if (!state.loading) {
                      props.history.push({
                        pathname: getEditUrl(URL_ADMIN_EDIT_EXHIBITIONS_ID, element.id)
                      })
                    }
                  }}
                />,
                <Popconfirm
                  key={element.id}
                  title='Are you sure？'
                  okText='Yes'
                  cancelText='No'
                  onConfirm={() => {
                    if (!state.loading) {
                      deleteArtworkExhibition(element.id)
                        .then(() => {
                          window.location.reload()
                        })
                        .catch((error) => {
                          HttpError(error)
                        })
                    }
                  }}
                >
                  <DeleteOutlined key='delete' />
                </Popconfirm>
              ]}
            >
              <Row justify='space-between' align='middle'>
                <Meta
                  title={
                    <a
                      href={getExhibitionDetailUrl(element.id, element.title)}
                      target={'_blank'}
                      style={{ whiteSpace: 'pre-line' }}
                      rel='noreferrer'
                    >
                      {'# ' + element.id + ', ' + element.title}
                    </a>
                  }
                />
                <Meta
                  description={
                    <>
                      <p
                        style={{
                          whiteSpace: 'pre-line',
                          marginTop: 12
                        }}
                      >
                        {element.date + ', ' + element.location}
                      </p>
                      <p>{element.desc}</p>
                    </>
                  }
                />
              </Row>
            </Card>
          </Col>
        )
      })
      return (
        <Row justify='flex-start' gutter={{ xs: 8, sm: 16, md: 24 }} style={{ marginTop: '16px' }}>
          {items}
        </Row>
      )
    }

    return (
      <Spin size='large' spinning={this.state.loading}>
        <div className='site-layout-background'>
          <Row align='middle' gutter={{ xs: 8, sm: 16, md: 24 }}>
            <Col>
              <Title style={{ marginBottom: 0 }}>Exhibitions</Title>
            </Col>
            <Col style={{ paddingTop: 12 }}>
              <Button
                icon={<FileAddOutlined />}
                size='large'
                onClick={(event) => {
                  this.props.history.push({ pathname: URL_ADMIN_NEW_EXHIBITIONS })
                }}
                style={{ verticalAlign: 'middle' }}
              >
                Add New
              </Button>
            </Col>
          </Row>
          <Divider style={{ marginBottom: 12, marginTop: 12 }} />
          {getExhibitionsLayout(this.state, this.props)}
        </div>
      </Spin>
    )
  }
}

export default withRouter(Exhibitions)
